import React, { useState } from 'react';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import { Button, Grid } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useForm } from '../../../../hooks/useForm';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { CboTipoFeriados } from '../../../cbos/CboTipoFeriados';
import { CentrosMedicos } from './CentrosMedicos';
import { agregarEditarFeriado } from '../../../../actions/turnos/feriados';
import { TIPO_FERIADO } from '../../../../utils/constants';
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { armarParametros } from '../../../../helpers/parametros';
import { finishSpinner, startSpinner } from '../../../../actions/ui/spinner';
import { fetchConToken } from '../../../../helpers/fetch';
import { startAlerta } from '../../../../actions/ui/alertas';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 20,
    },
    grid: {
        padding: 15,
        paddingLeft: 50,
        paddingRight: 50
    },
    gridBackground: {
        backgroundColor: 'white',
    },
    botonera: {
        marginTop: 25,
        marginLeft: 55,
        paddingBottom: 13
    },
    roles: {
        float: "left",
        marginLeft: 15,
    },
    formControl: {
        marginTop: 15,
        width: 183,
        textAlign: "left"
    },
}));

export const Feriado = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { seleccionado: feriadoSeleccionado, items: itemsFeriados } = useSelector((state) => state.feriados);
    const { items: itemsCentrosMedicos } = useSelector((state) => state.centrosMedicosPropios);

    const [ formValues, handleInputChange ] = useForm( feriadoSeleccionado );
    const { idFeriado, idTipoFeriado, feriado, descripcionFeriado } = formValues;
    const [ turnosTomados, setTurnosTomados ] = useState(0);
    const [ openQuestion, setOpenQuestion ] = useState(false);
    const [ openQuestionTurnos, setOpenQuestionTurnos ] = useState(false);

    const handleVerifyChanges = () => {
        const verificarTurnosTomados = async () => {
            setTurnosTomados(0);
            setOpenQuestion(false);
            try{
                dispatch(startSpinner());
                const parametros = armarParametros(null, null, null, null, null, feriado.toISOString(), null, null, null, null, null, null, null, null, null, true);
                const response = await fetchConToken(`Agenda/traerPorFecha?${parametros}`);
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    const lista = await response.json();
                    if (response.status !== 200) throw lista.errores;
                    if(lista.length > 0){                       //Valido si tiene turnos tomados para esa fecha
                        setTurnosTomados(lista);
                        setOpenQuestionTurnos(true);
                    }else{
                        handleSave();
                    }
                }
                dispatch(finishSpinner());
            } catch (err){
                dispatch(finishSpinner());
                dispatch(startAlerta(err, "warning", `¡Error!`));
            }
        };

        const feriadoOriginal = itemsFeriados.find(s => s.idFeriado === idFeriado);
        if(idTipoFeriado === TIPO_FERIADO.FERIADO_NACIONAL && (feriadoOriginal.idTipoFeriado !== idTipoFeriado || !moment(feriadoOriginal.feriado).isSame(feriado))){
            verificarTurnosTomados();
        }
        else{
            handleSave();
        }
    }

    const handleSave = () => {
        dispatch( agregarEditarFeriado(feriado, idTipoFeriado, descripcionFeriado, idFeriado, closeModal) );
    }

    const closeModal = () => {
        setOpenQuestion(false);
        setOpenQuestionTurnos(false);
    }

    return ( 
        <>
            {feriadoSeleccionado && (
                <>
                    <ValidatorForm onSubmit={() => setOpenQuestion(true)} className={classes.root}>
                        <Grid item container justify='center'>
                            <Grid item xs={8} className={classes.gridBackground}>
                                <Grid item container >
                                    <Grid item xs={12} md={4} className={classes.grid}>
                                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Fecha"
                                                format="dd/MM/yyyy"
                                                minDate={new Date()}
                                                value={feriado}
                                                onChange={(e) => handleInputChange({target: {name: 'feriado', value: e}})}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} md={4} className={classes.grid}>
                                        <CboTipoFeriados
                                            manejadorInputChange={handleInputChange}
                                            name={'idTipoFeriado'}
                                            valor={idTipoFeriado}
                                        />
                                    </Grid>
                                    <Grid item xs={12} className={classes.grid} style={{paddingTop: 0}}>
                                        <TextValidator
                                            fullWidth
                                            margin="normal"
                                            label="Descripcion"
                                            name="descripcionFeriado"
                                            value={descripcionFeriado}
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            validators={["required"]}
                                            errorMessages={["Este campo es obligatorio"]}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={8} className={classes.gridBackground} style={{textAlign: 'right', paddingRight: 50, paddingBottom: 25}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    startIcon={<SaveIcon />}
                                    type="submit"
                                >
                                    GUARDAR
                                </Button>
                            </Grid>
                            {feriadoSeleccionado.idTipoFeriado !==1 &&
                                <Grid item xs={8} className={classes.gridBackground}>
                                    <Grid item container >
                                        <CentrosMedicos
                                            fecha={feriado}
                                            idFeriado={idFeriado}
                                            itemsCentrosMedicos={itemsCentrosMedicos} 
                                            centrosMedicosFeriadoSeleccionado={feriadoSeleccionado.feriadosCentros}
                                        />
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                        {openQuestion && 
                            <AlertFinalizadoStepper
                                open={openQuestion}
                                pregunta={"Modificación de Feriado"}
                                dialogText={"Se van a realizar cambios en el feriado, esto generará cambios en agendas de prestadores, está seguro?"}
                                buttonCancel={"Cancelar"}
                                buttonSubmit={"Continuar"}
                                handleClose={() => setOpenQuestion(false)}
                                handleSend={handleVerifyChanges}
                            />
                        }
                        {openQuestionTurnos && 
                            <AlertFinalizadoStepper
                                open={openQuestionTurnos}
                                pregunta={`Turnos tomados`}
                                dialogText={`Se van a cancelar ${turnosTomados.length} turnos tomados esta seguro?`}
                                buttonCancel={"Cancelar"}
                                buttonSubmit={"Continuar"}
                                handleClose={() => setOpenQuestionTurnos(false)}
                                handleSend={handleSave}
                            />
                        }  
                    </ValidatorForm>
                </>
            )}
        </>       
     );
}